import { Link as MuiLink, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import LangEnum from '../lang/LangEnum';
import { useTranslation } from '../modules/translation/TranslationContext';

type PrivacyPoliticsProps = {
  label?: string;
  actionLabel: string;
  fontSize?: 'small' | 'medium' | 'large';
  color?:
    | 'inherit'
    | 'initial'
    | 'textSecondary'
    | 'primary'
    | 'secondary'
    | 'textPrimary'
    | 'error';
};

export const privacyPoliticsUrl = 'https://teceo.co/pt/privacy-policy/';
export const termsOfUseUrl = 'https://teceo.co/pt/terms-of-use/';

const useStyles = makeStyles()(() => ({
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

const PrivacyPolitics = ({
  label,
  actionLabel,
  fontSize = 'small',
  color = 'textSecondary',
}: PrivacyPoliticsProps) => {
  const { translate } = useTranslation();
  const { classes } = useStyles();

  const getFontSize = () => {
    if (fontSize === 'large') {
      return 16;
    }
    if (fontSize === 'medium') {
      return 14;
    }
    return 12;
  };
  return (
    <Typography style={{ fontSize: getFontSize() }} color={color}>
      {label ||
        translate(LangEnum.PRIVACY_POLITICS_YOU_AGREE_WITH_DEFAULT_LABEL, {
          actionLabel,
        })}
      {translate(LangEnum.PRIVACY_POLITICS_YOU_AGREE_WITH)}
      <MuiLink
        href={privacyPoliticsUrl}
        target="_blank"
        rel="noreferrer"
        className={classes.link}
        color={color}
        underline="hover"
      >
        {translate(LangEnum.PRIVACY_POLITICS_PRIVACY_POLICY)}
      </MuiLink>
      {` `} {translate(LangEnum.PRIVACY_POLITICS_AND_OURS)} {` `}
      <MuiLink
        href={termsOfUseUrl}
        target="_blank"
        rel="noreferrer"
        className={classes.link}
        color={color}
        underline="hover"
      >
        {translate(LangEnum.PRIVACY_POLITICS_TERMS_OF_USE)}
      </MuiLink>
      .
    </Typography>
  );
};

export default PrivacyPolitics;
